import React, { FC } from 'react';
import eye_img from '../../../assets/icons/eye.svg';
import eye_off_img from '../../../assets/icons/eye-on-off.svg';

interface IProps {
    hideForPresenter: boolean;
}

const HideForPresenter: FC<IProps> = ({ hideForPresenter }) => {
  return (
    <>
      {hideForPresenter
        ? <div className='poll-presenter-hidden'><img src={eye_off_img}/>Hidden from Presenter</div>
        : <div className='poll-presenter-visibile'><img src={eye_img}/>Visible for Presenter</div>
      }
    </>
  );
};

export default HideForPresenter;